export enum SortDirectionEnum {
    ASCENDING = 'asc',
    DESCENDING = 'desc',
    NONE = ''
}
